import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { modalActions } from '../../../../Modals/store';
import { ROUTES } from '../../../../../routes/constants';
import WorkerChairMenu from '../WorkerChairMenu';
import styles from './WorkerRetailModal.module.scss';

const WorkerRetailModal = ({
  closeModal,
  worker,
  modalData,
  tasks = [],
  sOModalData,
  hasOverlappingBookings = false,
  queueCount = 0,
  canManageChair = false,
  workerQueue = null,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const openShare = (event) => {
    event?.stopPropagation();
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'workerSoldOutModal',
        props: { worker, modalData: sOModalData, tasks },
      }),
    );
  };

  const openQueue = (event) => {
    event?.stopPropagation();
    dispatch(
      modalActions.OPEN_MODAL.SUCCESS({
        type: 'clientsQueueModal',
        props: {
          workers: workerQueue ? [workerQueue] : [],
          clientsLength: queueCount,
        },
      }),
    );
  };

  return (
    <div className={styles.sheet}>
      <WorkerChairMenu
        hasOverlappingBookings={hasOverlappingBookings}
        modalData={modalData}
        tasks={tasks}
        queueCount={queueCount}
        canManageChair={canManageChair}
        onShare={openShare}
        onQueue={openQueue}
        onManage={() => {
          closeModal();
          navigate(
            `${ROUTES.SALON_MANAGEMENT}${ROUTES.WORKERS}${ROUTES.WORKING_TIME}/${worker.id}`,
          );
        }}
      />
    </div>
  );
};

export default WorkerRetailModal;
